import * as React from 'react';
import styled from 'styled-components';

import { TrackedLink } from '@origin-digital/ods-core';

import { InlineSvg } from '../Svg';
import { ANIMATION, BREAK_POINTS, COLOURS } from '../../consts/style';
import { ChevronRight } from '../../images/svg/ChevronRight';

const QuickLinkItem = styled(TrackedLink)`
  position: relative;
  box-sizing: border-box;
  background: white;
  display: flex;
  flex-direction: row;
  text-decoration: none;
  height: 56px;
  flex-basis: 100%;

  width: 100%;
  padding: 16px 8px 16px 16px;
  border-bottom: 1px solid ${COLOURS.GREY.GREY_16};

  &:hover {
    background: ${COLOURS.GREY.GREY_4};
  }

  &:hover svg {
    transform: scale(${ANIMATION.ICON.SCALE});
  }

  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    flex-direction: column;
    height: 160px;
    flex-basis: 100%;
    border-bottom: none;
    border-right: 1px solid ${COLOURS.GREY.GREY_16};
    padding: 0;
    &:last-child {
      border-right: 0;
    }
  }
  @media (max-width: ${BREAK_POINTS.MAX.SM}) and (min-width: 390px) {
    flex-basis: 50%;
    &:nth-child(odd) {
      border-right: 1px solid ${COLOURS.GREY.GREY_16};
    }
    &:nth-child(2n + 1):nth-last-child(-n + 2),
    &:nth-child(2n + 1):nth-last-child(-n + 2) ~ a {
      border-bottom: none;
    }
  }
`;

const StyledInlineSvg = styled(InlineSvg)`
  & svg {
    height: 24px;
    width: 24px;
    margin-right: 16px;
    color: ${COLOURS.PRIMARY.ORANGE_LIGHT};
    fill: ${COLOURS.PRIMARY.ORANGE_LIGHT};
    transition: transform ${ANIMATION.ICON.SPEED};
  }
  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    & svg {
      display: block;
      margin: 36px auto 10px auto;
      height: 48px;
      width: 48px;
      color: ${COLOURS.PRIMARY.ORANGE_LIGHT};
      fill: ${COLOURS.PRIMARY.ORANGE_LIGHT};
    }
  }
`;

const Headline = styled.span`
  position: relative;
  flex: 1 1 auto;
  color: ${COLOURS.GREY.GREY_80};
  line-height: 24px;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    line-height: 18px;
    text-align: center;
  }
`;

const StyledChevron = styled.span`
  svg {
    height: 24px;
    width: 24px;
    color: ${COLOURS.GREY.GREY_48};
    fill: ${COLOURS.GREY.GREY_48};
  }
  @media (min-width: ${BREAK_POINTS.MIN.SM}) {
    display: none;
  }
`;

export const QuickLinkRedesign = ({ headline, url, icon }) => (
  <QuickLinkItem
    trackingType="CustomLink"
    trackingLabel={headline}
    href={url}
    data-comment="QuickLink"
    data-id={`quickLink-${headline}`}
  >
    <StyledInlineSvg html={icon} />
    <Headline>{headline}</Headline>
    <StyledChevron>
      <ChevronRight />
    </StyledChevron>
  </QuickLinkItem>
);
